import TPS from './TPS';

// TPS base class
window.tps = new TPS();

// On DOM ready
window.tps.onDomReady();
